function formValidation(formValues) {
  let errors = {};
  if (!formValues.firstName.trim()) {
    errors.firstName = "Username required";
  }
  if (!formValues.email) {
    errors.email = "Email required";
  } else if (!/\S+@\S+\.\S+/.test(formValues.email)) {
    errors.email = "Email address is invalid";
  }
  if (!formValues.message.trim()) {
    errors.message = "Message required";
  }
  return errors;
}

export default formValidation;
